export default {
    
    en: {
        title: 'Approval Management',
        allTitle: 'All Approval Tasks',
        mytitle: 'My Approval Tasks',
        historytitle: 'History Approval Tasks',
        performancetitle: 'Approval Performance',
        invoke: 'Invoke Order',

        examinerName: 'Examiner Name',
        examineTime: 'Examine Time',
        approvalTotal: 'Total Approvals',
        approvalNum: 'Approved Number',
        ApprovalRejectNum: 'Approval Reject Number',
        ApprovalCancleNum: 'Approval Cancle Number',
        approvalRate: 'Approved Rate',
        overdueNum: 'Overdue Number',
        overdueRate: 'Overdue Rate',
        q1:"Does the call gets connected to the client?",
        yes:"Yes",
        noresponse:"No Response",
        invalidnumber:"Invalid Number",
        switchoff:"Switch off",
        reject:"Reject",
        no:"No",
        q2:"Does the borrower confirm that all information provided has been filled by themselves?",
        q3:"Is the borrower able to verify his/her registered Mobile number immediately?",
        q4:"Is the borrower able to verify his/her date of birth?",
        q5:"Does the borrower have any complaints on loan duration and loan amount?",
        q6:"Are you able to reach on the alternate contact number?",
        q7:"Does alternate contact know the borrower?",
    }
}
